import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_SudItp = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_SudItp' className='file-pdf-document'>
            <div className='file-template'>
             <h2>SERVICE AND SERVICE FREQUENCY</h2>

                <table>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Service and Staff Providing Service:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Service Frequency:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_1' name='cbService_1' className='add-only' value='Service_1' />
                            <b>SUD Assessment and ASAM Level of Care </b>
                            <br />
                            Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbSerFrequencyAnnually_1' name='rbSerFrequency_1' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_1' name='rbSerFrequency_1' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_2' name='cbService_2' className='add-only' value='Service_2' />
                            <b>SUD Case Management</b>
                            <br />QBHS, Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbSerFrequencyAnnually_2' name='rbSerFrequency_2' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_2' name='rbSerFrequency_2' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_3' name='cbService_3' className='add-only' value='Service_3' />
                            <b>SUD Psychotherapy (Individual, Family)</b>
                            <br />Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbSerFrequencyAnnually_3' name='rbSerFrequency_3' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_3' name='rbSerFrequency_3' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_4' name='cbService_4' className='add-only' value='Service_4' />
                            <b>SUD Psychotherapy Group </b>
                            <br />Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbSerFrequencyAnnually_4' name='rbSerFrequency_4' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_4' name='rbSerFrequency_4' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_5' name='cbService_5' className='add-only' value='Service_5' />
                            <b>SUD Individual Counseling </b>
                            <br />CDCA professionals only
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbSerFrequencyAnnually_5' name='rbSerFrequency_5' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_5' name='rbSerFrequency_5' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_6' name='cbService_6' className='add-only' value='Service_6' />
                            <b>Intensive Outpatient</b>
                            <br />Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>

                            <input type='radio' id='rbSerFrequencyAnnually_6' name='rbSerFrequency_6' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_6' name='rbSerFrequency_6' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_7' name='cbService_7' className='add-only' value='Service_6' />
                            <b>PEER Supporter</b>
                            <br />Licensed professional as identified in OAC 5122-29-15.1
                        </td>
                        <td className='w-250'>

                            <input type='radio' id='rbSerFrequencyAnnually_7' name='rbSerFrequency_7' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_7' name='rbSerFrequency_7' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_8' name='cbService_8' className='add-only' value='Service_6' />
                            <b>Laboratory Analysis</b>
                            <br />Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>

                            <input type='radio' id='rbSerFrequencyAnnually_8' name='rbSerFrequency_8' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_8' name='rbSerFrequency_8' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbService_9' name='cbService_9' className='add-only' value='Service_6' />
                            <b>Medication Management</b>
                            <br />Licensed professionals as identified in OAC 5122-29-03
                        </td>
                        <td className='w-250'>
                            <span className='small'>Determined by medical provider</span>
                            <input type='radio' id='rbSerFrequencyAnnually_9' name='rbSerFrequency_9' className='add-only' value='Annually' /> Annually or &nbsp;
                            <input type='radio' id='rbSerFrequencyClinicay_9' name='rbSerFrequency_9' className='add-only' value='Clinically' /> Clinically Indicated
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>ASAM Level of Care </span>
                    <span className='small'>(as identified from client's Diagnostic Evaluation or SUD Assessment)</span>
                </p>
                <table>
                    <tr>

                        <td className='w-375'> <input type='checkbox' id='cbLevelofCare_1' name='cbLevelofCare_1' className='add-only' value='Level 1 Outpatient' /> Level 1 Outpatient        </td>
                        <td className='w-375'> <input type='checkbox' id='cbLevelofCare_2' name='cbLevelofCare_2' className='add-only' value='Level 2.1 Intensive Outpatient' /> Level 2.1 Intensive Outpatient      </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbLevelofCare_3' name='cbLevelofCare_3' className='add-only' value='Level 3.1 Halfway House' /> Level 3.1 Halfway House      </td>
                        <td className='w-375'> <input type='checkbox' id='cbLevelofCare_4' name='cbLevelofCare_4' className='add-only' value='Level 3.5 Non-medical Residential' /> Level 3.5 Non-medical Residential </td>

                    </tr>
                </table>

                <h2>STRENGTHS, NEEDS, ABILITIES, PREFERENCES (SNAP)</h2>

                <p className='w-750'>
                    <span className='eleHeader'>Client Strengths</span>
                    <span className='small'>(What are some things that will help you in treatment?)</span>
                    <textarea id='txtClientStrengths' name='txtClientStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Needs</span>
                    <span className='small'>(What do you want to learn in treatment?):</span>
                    <textarea  id='txtClientNeeds' name='txtClientNeeds' className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Abilities</span>
                    <span className='small'>(What are some of your personal qualities, skills, or talents that will help you in treatment?) </span>
                    <textarea  id='txtClientAbilities' name='txtClientAbilities' className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Preferences</span>
                    <span className='small'>(What do you hope to get out of treatment?): </span>
                    <textarea  id='txtClientPreferences' name='txtClientPreferences' className='add-only'></textarea>

                </p>

                <h2>PROBLEM/GOALS/METHODS AND TARGET OUTCOME RATING</h2>

                <p className='w-750'>
                    <span className='small'>(Either increase, decrease or extinguish frequency, intensity, duration)</span>

                    <span className='eleHeader'>Problem Addressed: </span>
                    <textarea placeholder='{Choose Problem}' id='txtProblem' name='txtProblem' className='add-only'></textarea>

                    <span className='eleHeader'>Problem Statement: </span>
                    <textarea id='txtProblemStatement' name='txtProblemStatement' className='add-only'></textarea>

                    <span className='eleHeader'>Comments</span>
                    <span className='small'>(describe problem in specific detail): </span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>

                    <span className='eleHeader'>Goal Statement:</span>
                    <textarea id='txtGoalStatement' name='txtGoalStatement' className='add-only'></textarea>
                </p>

                <h2>PROBLEM SEVERITY AND TARGET OUTCOME  </h2>

                <p className='w-750'>
                    <span className='small'>Mild  2-3; Moderate 4-6; Serious  7-8 ; Severe 9-10 : </span>
                </p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Current severity of problem: </span></td>
                        <td className='w-200'><span className='eleHeader'>Target outcome rating: </span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrent' name='txtCurrent'  className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtTarget' name='txtTarget'  className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Goal in Client's Own Words:</span>
                    <textarea id='txtGoal' name='txtGoal' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date Identified:  </span></td>
                        <td className='w-375'><span className='eleHeader'>Target Completion Date: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateIdentified' name='txtDateIdentified' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtCompletionDate' name='txtCompletionDate' className='add-only' /> </td>
                    </tr>
                </table>

                <h4>All Methods/Interventions provided with the assistance of LSS eligible providers</h4>



                <p className='w-750'>
                    <span className='eleHeader'>Method 1 </span>
                    <span className='small'>(Intervention):</span>
                    <textarea id='txtmethod_1' name='txtmethod_1' className='add-only'></textarea>


                    <span className='eleHeader'>Method 2 </span>
                    <span className='small'>(Intervention):</span>
                    <textarea id='txtmethod_2' name='txtmethod_2' className='add-only'></textarea>

                    <span className='eleHeader'>Method 3 </span>
                    <span className='small'>(Intervention):</span>
                    <textarea id='txtmethod_3' name='txtmethod_3' className='add-only'></textarea>

                    <span className='eleHeader'>Method 4 </span>
                    <span className='small'>(Intervention):</span>
                    <textarea id='txtmethod_4' name='txtmethod_4' className='add-only'></textarea>

                    <span className='eleHeader'>Method 5 </span>
                    <span className='small'>(Intervention):</span>
                    <textarea id='txtmethod_5' name='txtmethod_5' className='add-only'></textarea>

                    <span className='eleHeader'>Additional Information</span>
                    <textarea id='txtAdditional' name='txtAdditional' className='add-only'></textarea>
                </p>

                <h2>MEDICAL NECESSITY</h2>

                <p className='w-750'>

                    <span className='small'>( Mild 2-3; Moderate 4-6; Serious  7-8; Severe 9-10) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Severity of Symptoms:  </span></td>
                        <td className='w-375'><span className='eleHeader'>Levels of functioning impairment:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSeverity' name='txtSeverity'  className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLevels' name='txtLevels'  className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Area of Functioning Impairment  </span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_1' name='cbImpairment_1' className='add-only' value='WorkOccupation' /> Work/occupation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_2' name='cbImpairment_2' className='add-only' value='School' /> School
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_3' name='cbImpairment_3' className='add-only' value='Family' /> Family Relations
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_5' name='cbImpairment_5' className='add-only' value='Social' /> Social
                        </td>
                    </tr>

                    <tr>

                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_6' name='cbImpairment_6' className='add-only' value='Judgment ' /> Judgment
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_7' name='cbImpairment_7' className='add-only' value='Thinking' /> Thinking
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairment_8' name='cbImpairment_8' className='add-only' value='Mood' /> Mood
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the DSM 5 diagnosis with a description of functioning and symptoms?   </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbFunctioningSymptoms_Yes' name='rbFunctioningSymptoms' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFunctioningSymptoms_No' name='rbFunctioningSymptoms' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <h2> CLINICAL RECOMMENDATIONS AND TRANSITION PAN</h2>

                <p className='w-750'>
                    <span className='eleHeader'>Without treatment, will the client be expected to suffer prolonged, increased or new psychiatric symptoms or impairment of functioning? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbImpairmentFunctioning_Yes' name='rbImpairmentFunctioning' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbImpairmentFunctioning_No' name='rbImpairmentFunctioning' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What is the client's transition plan?  </span>
                    <textarea  id='txtplan' name='txtplan' className='add-only'></textarea>

                    <span className='small'> *ITP to be reviewed every 90 days, at client's request, as clinically indicated, or adding/ terminating of a service</span>
                </p>
                <h2>ITP GOAL REVIEW</h2>

                <p className='w-750'>
                    <span className='eleHeader'>Reason for Review: </span>
                    <textarea  id='txtReason' name='txtReason' className='add-only'></textarea>

                    <span className='eleHeader'>Progress: </span>

                    <textarea  id='txtProgress' name='txtProgress' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>New Target date  </span></td>


                    </tr>
                    <tr>
                        <td><span className='small'>(if previous goal continued): </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='Date' id='txtNew' name='txtNew' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGoalService' name='cbGoalService' className='add-only' value='GoalService' />
                            <b>Previous goal(s) discontinued</b>
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Remarks regarding client's progress: </span>
                    <textarea id='txtRemarks' name='txtRemarks' className='add-only'></textarea>

                </p>
                <p>
                    <b>SIGNATURES</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Client's Signature (sign above) </td>
                        <td className='small w-250'> Printed Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Parent/Legally Authorized representative Signature  </td>
                        <td className='small w-250'> Printed Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Other (Specify)  </td>
                        <td className='small w-250'> Printed Name </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Staff/Credentials  </td>
                        <td className='small w-250'> Printed Name/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Provider/Credentials (if applicable)  </td>
                        <td className='small w-250'> Printed Name/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Supervisor/Credentials (if applicable)  </td>
                        <td className='small w-250'> Printed Name/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Physician Signature/Credentials (if applicable)  </td>
                        <td className='small w-250'> Printed Name/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>
            </div>
        </form>
            
    )
 }

                



